<template>
  <v-container>
    <v-row class="text-left">
      <v-col>
        <h1>{{ $t('userSettings.userSettings') }}</h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col  class="text-right" >
        <VersionInfo />
      </v-col>
    </v-row>
    <v-sheet outlined class="rounded-xl">
      <router-view />
    </v-sheet>
  </v-container>
</template>
<script>
import VersionInfo from "@/components/System/VersionInfo.vue";
export default {
  components: {
    VersionInfo,
  },
}
</script>